/**
 * SettingsService.js
 * This service provides access to the plugin's settings and configuration data. fetched at startup from
 * the global window.TCRS2PluginData object.
 * The data is originally fetched from the WordPress backend.
 */

const SettingsService = {
  getPluginUrl: () => {
    return window.TCRS2PluginData?.pluginUrl || '';
  },

  getStripePublicKey: () => {
    return window.TCRS2PluginData?.generalSettings?.stripe_public_key || '';
  },

  getPrivacyPolicyUrl: () => {
    return window.TCRS2PluginData?.generalSettings?.private_policy || '#';
  },

  getTermsAndConditionsUrl: () => {
    return window.TCRS2PluginData?.generalSettings?.terms_and_conditions || '#';
  },

  getVatRate: () => {
    return parseFloat(window.TCRS2PluginData?.generalSettings?.vatRate) || 0;
  },

  getLanguage: () => {
    return window.TCRS2PluginData?.generalSettings?.language || 'en';
  },

  getCountryShortCode: () => {
    return window.TCRS2PluginData?.generalSettings?.countryShortCode || 'dk';
  },

  getCountry: () => {
    return window.TCRS2PluginData?.generalSettings?.country_name || 'Denmark';
  },

  getEmailNotifications: () => {
    return window.TCRS2PluginData?.generalSettings?.emailNotifications || '';
  },

  getMapZoomLevel: () => {
    return window.TCRS2PluginData?.generalSettings?.zoomLevel || 5;
  },

  getMapCoordinates: () => {
    return window.TCRS2PluginData?.generalSettings?.world_map_coordinates || '';
  },

  getCurrency: () => {
    return window.TCRS2PluginData?.generalSettings?.currency || 'DKK';
  },

  getFormPage: () => {
    return window.TCRS2PluginData?.generalSettings?.formPage || 'faa-et-tilbud';
  },

  getClosedPeriod: () => {
    return (
      parseInt(window.TCRS2PluginData?.generalSettings?.closedPeriod, 10) || 0
    );
  },

  getUseDailyRates: () => {
    return Boolean(window.TCRS2PluginData?.generalSettings?.useDailyRates);
  },

  // Returns the '_daily' variant of a translation key when daily rates are enabled.
  getRateTranslationKey: (key) => {
    return SettingsService.getUseDailyRates() ? `${key}_daily` : key;
  },

  // Online booking is closed for the first N days of each month (day 1..N).
  isOnlineBookingClosed: () => {
    const closedPeriod = SettingsService.getClosedPeriod();
    if (closedPeriod <= 0) {
      return false;
    }
    return new Date().getDate() <= closedPeriod;
  },
};

export default SettingsService;
